import { Address } from "../../../../../features/address"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { TableName } from "../../../../../tables"
import { Customer, useCustomerService, useSaleOperationService } from "../../../../sales"
import { DeliveryData } from "../../../state/types"

export const useActions = () => {
    const { updateSaleOperationProps } = useSaleOperationService()
    const { updateCustomerProps } = useCustomerService()

    const submitCustomerDeliveryAddress = (
        customer: Customer,
        address: Address,
    ) => {
        const deliveryAddresses = customer.deliveryAddresses.concat(address)
        return updateCustomerProps(customer.id, { deliveryAddresses })
    }

    const submitDeliveryData = async (
        table: TableName,
        operationId: string,
        partialDeliveryData?: Partial<DeliveryData>
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const deliveryData = partialDeliveryData?.method ? {
            ...partialDeliveryData,
            method: partialDeliveryData.method
        } : undefined
        
        await updateSaleOperationProps(table, operationId, { deliveryData })
        
        Emitter.emit(Event.DB_SUBMIT_DONE)
    }

    return {
        submitCustomerDeliveryAddress,
        submitDeliveryData
    }
}
